import * as React from 'react';
import Highlight from 'react-highlight';
import Helmet from 'react-helmet';
import {removeBlankLines, removeWhiteSpace, indentCodeBlock} from '../../utils';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import './exportCode.scss';

export default class ExportCode extends React.Component {

    constructor() {
        super();
        this.state = { copyText: 'Copy Snippet' };
        this.copyToClipboardTimeout = null;
    }

    getProps = (copy, transitionOptions) => {

        return `${transitionOptions.opacity ? `animateOpacity={${transitionOptions.opacity ? 'true' : 'false'}}` : ''}
            canPlay={true}
            ${['character'].includes(transitionOptions.reveal) ? `characterOffsetDelay={${transitionOptions.characterOffsetDelay}} // ms` : ''}
            ${['character'].includes(transitionOptions.reveal) ? `characterWordSpacing={"${transitionOptions.characterWordSpacing}px"}` : ''}
            copy={[${copy.split("\n").map(word => `"${word}"`)}]}
            ${transitionOptions.direction ? `direction={"${transitionOptions.direction}"}` : ''}
            ${transitionOptions.duration ? `duration={${transitionOptions.duration}} // ms` : ''}
            ${transitionOptions.bezierCurve ? `ease={"cubic-bezier(${transitionOptions.bezierCurve})"}` : ''}
            ${transitionOptions.offset ? `offset={"${transitionOptions.offset}px"}` : ''}
            ${transitionOptions.opacityDelay ? `opacityDelay={${transitionOptions.opacityDelay}} // ms` : ''}
            ${transitionOptions.perspective ? `perspective={${transitionOptions.perspective}}` : ''}
            ${transitionOptions.perspective && transitionOptions.perspectiveFOV ? `perspectiveFOV={${transitionOptions.perspectiveFOV}} // px` : ''}
            ${transitionOptions.perspective && transitionOptions.perspectiveX ? `perspectiveX={${transitionOptions.perspectiveX}}` : ''}
            ${transitionOptions.perspective && transitionOptions.perspectiveY ? `perspectiveY={${transitionOptions.perspectiveY}}` : ''}
            ${transitionOptions.perspective && transitionOptions.perspectiveZ ? `perspectiveZ={${transitionOptions.perspectiveZ}}` : ''}
            ${['word'].includes(transitionOptions.reveal) ? `wordOffsetDelay={${transitionOptions.wordOffsetDelay}}` : ''}
            ${['word', 'multiline', 'character'].includes(transitionOptions.reveal) ? `multilineMasking={${transitionOptions.multilineMasking ? 'true' : 'false'}}` : ''}
            ${['word', 'multiline', 'character'].includes(transitionOptions.reveal) ? `multilineOffsetDelay={${transitionOptions.multilineOffsetDelay}} // ms` : ''}`
    }

    getImportCode = () => {
        const {transitionOptions} = this.props;
        switch(transitionOptions.reveal) {
            case 'all':
                    return removeWhiteSpace(`
                        import {AllReveal} from "react-text-reveal";
                    `);
    
                case 'multiline':
                    return removeWhiteSpace(`
                        import {MultilineReveal} from "react-text-reveal";
                    `);
    
                case 'word': 
                return removeWhiteSpace(`
                    import {WordReveal} from "react-text-reveal";
                `);
    
                case 'character': 
                    return removeWhiteSpace(`
                        import {CharacterReveal} from "react-text-reveal";
                    `);
    
                default:
                    return null;
        }
    }
	
    getExportCode = () => {
        const {copy, transitionOptions} = this.props;
    
        switch(transitionOptions.reveal) {
            case 'all':
                return indentCodeBlock(removeBlankLines(removeWhiteSpace(`
                    <Reveal 
                        ${this.getProps(copy, transitionOptions)}
                    />
                `)));

            case 'multiline':
                return indentCodeBlock(removeBlankLines(removeWhiteSpace(`
                    <MultilineReveal
                        ${this.getProps(copy, transitionOptions)}
                    />
                `)));

            case 'word': 
                return indentCodeBlock(removeBlankLines(removeWhiteSpace(`
                    <WordReveal
                        ${this.getProps(copy, transitionOptions)}
                    />
                `)));

            case 'character': 
                return indentCodeBlock(removeBlankLines(removeWhiteSpace(`
                    <CharacterReveal
                        ${this.getProps(copy, transitionOptions)}
                    />
                `)));

            default:
                return null;

        }
    }

    onCopy = () => {
        this.setState({ copyText: 'Copied'});
        clearTimeout(this.copyToClipboardTimeout);
        this.copyToClipboardTimeout = setTimeout(() => {
            this.setState({ copyText: 'Copy Snippet'});
        }, 2000);
    }

    render() {
        const {copyText} = this.state;

        return <>
            <Helmet>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.12.0/styles/atelier-cave-dark.min.css" />
            </Helmet>
            <Highlight language="console">
                {`$ npm i -D react-text-reveal`}
            </Highlight>
            <Highlight language="javascript">
                {removeBlankLines(this.getImportCode())}
            </Highlight>
            <Highlight language="javascript">
                {this.getExportCode()}
            </Highlight>
            <CopyToClipboard text={this.getExportCode()}
                onCopy={this.onCopy}>
                <button className="copy-btn">{copyText}</button>
            </CopyToClipboard>
      </>
    }
}
